import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Input } from "antd";
import sha256 from "sha256";

const FormItem = Form.Item;

class ExpiredPassword extends Component {
  static propTypes = {
    auth: PropTypes.object,
    email: PropTypes.string,
    resetLogin: PropTypes.func,
    updatePassword: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      passwordValue: "",
      password: {
        help: "",
        status: ""
      },
      passwordConfirmValue: "",
      passwordConfirm: {
        help: "",
        status: ""
      }
    };
  }

  /* componentDidMount() {
    const { email, resetLogin } = this.props;
    if (!email || email === "") {
      resetLogin();
    }
  }*/

  handleSubmit(e) {
    const { auth, email, updatePassword } = this.props;
    const { passwordValue, passwordConfirmValue } = this.state;
    e.preventDefault();

    let errorType = "";
    let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*+.])(?=.{8,})");

    if (passwordValue === "") {
      errorType = "Inserisci la tua password";
    } else if (passwordConfirmValue !== passwordValue) {
      errorType = "Le password devono coincidere";
    } else if (!strongRegex.test(passwordValue)) {
      errorType = (
        <div>
          La password non è abbastanza complessa. <br />
          • La password deve essere lunga almeno 8 caratteri <br />e deve
          contenere:
          <br />
          • almeno una lettera maiuscola: A-Z <br />
          • almeno una lettera minuscola: a-z <br />
          • almeno un numero: 0-9 <br />
          • almeno un carattere speciale: !@#£%?ç$%^&*)(+=._- <br />
        </div>
      );
    }

    let passwordErr;

    if (errorType) {
      passwordErr = {
        action: this.setState({
          password: {
            status: "error",
            help: errorType
          }
        }),
        status: false
      };
    } else {
      passwordErr = {
        action: this.setState({
          password: { status: "", help: "" }
        }),
        status: true
      };
    }
    let errorConfirmType = "";
    if (passwordConfirmValue === "") {
      errorConfirmType = "Conferma la tua password";
    } else if (passwordConfirmValue !== passwordValue) {
      errorConfirmType = "Le password devono coincidere";
    }

    let passwordConfirmErr;

    if (errorConfirmType) {
      passwordConfirmErr = {
        action: this.setState({
          passwordConfirm: {
            status: "error",
            help: errorConfirmType
          }
        }),
        status: false
      };
    } else {
      passwordConfirmErr = {
        action: this.setState({
          passwordConfirm: { status: "", help: "" }
        }),
        status: true
      };
    }

    if (passwordErr.status && passwordConfirmErr.status) {
      let sha256UserPwd = null;
      if (passwordValue) {
        sha256UserPwd = sha256(email + passwordValue);
      }
      updatePassword(
        auth.oldAuth, email, sha256UserPwd
      );
    }
  }

  onChange(event, valueToUptade) {
    this.setState({
      [valueToUptade]: event.target.value
    });
  }

  render() {
    return (
      <div>
        <FormItem
          validateStatus={this.state.password.status}
          help={this.state.password.help}
        >
          <label>Nuova Password</label>
          <Input
            type="password"
            autoComplete="new-password"
            placeholder="Inserisci la tua password"
            value={this.state.passwordValue}
            onChange={e => this.onChange(e, "passwordValue")}
          />
        </FormItem>
        <FormItem
          validateStatus={this.state.passwordConfirm.status}
          help={this.state.passwordConfirm.help}
        >
          <label>Confema password</label>
          <Input
            type="password"
            placeholder="Conferma password"
            autoComplete="new-password"
            value={this.state.passwordConfirmValue}
            onChange={e => this.onChange(e, "passwordConfirmValue")}
          />
        </FormItem>
      </div>
    );
  }
}

export default ExpiredPassword;
